// extracted by mini-css-extract-plugin
export default {"container":"editing_container__bByFU","title":"editing_title__iH1x0","wrapper-fields":"editing_wrapper-fields__Pxe8x"};